import { createSlice } from "@reduxjs/toolkit";

// Re-export V2 Student type as the canonical Student type for this feature
export type { Student } from "@/features/academics/studentsV2/api/types";

interface StudentState {
  loading: boolean;
  error: string | null;
}

const initialState: StudentState = {
  loading: false,
  error: null,
};

const studentSlice = createSlice({
  name: "students",
  initialState,
  reducers: {},
});

export default studentSlice.reducer;
